module.exports = __webpack_public_path__ + "img/help_icon.0327e35a.svg";